import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stockApi } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export function useApproveStockEditRequestMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (requestId: number) => stockApi.approveEditRequest(requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.stockEditRequests() });
      queryClient.invalidateQueries({ queryKey: queryKeys.stock() });
      queryClient.invalidateQueries({ queryKey: queryKeys.stockMovements() });
    },
  });
}
